import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  userBox: {
    cursor: 'pointer',
    flex: 0,
  },
  signInButton: {
    textAlign: 'right',
  },
  logoContainer: {
    marginRight: theme.spacing(2),
    '& .MuiAvatar-root': {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: theme.spacing(1),
    },
    '& span': {
      display: 'none',
    },
    '@media (min-width: 480px)': {
      '& h6': {
        whiteSpace: 'nowrap',
      },
      '& span': {
        display: 'inline-block',
      },
    },
  },
}));

export default function Header() {
  const classes = useStyles();
  return (
    <AppBar position="sticky" color="default">
      <Toolbar>
        <Box flexGrow={1} className={classes.logoContainer}>
          <a href="https://matildaexp.com" target="_blank" rel="noreferrer">
            <Typography variant="h6" color="textPrimary">
              <Avatar alt="logo" src={`${process.env.PUBLIC_URL}/logo.png`} />
              <span>Matilda Explorations</span>
            </Typography>
          </a>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
